<template>
  <button
    type="button"
    :class="`btn ${classes} ${addClass}`"
    :style="[styles]"
    :disabled="disabled || loading || dependencies"
    @click="clicked"
  >
    <div v-if="!loading">
      {{ $t(text) }}</div>
    <div
      v-else
      class="spinner-border spinner-border-sm"
      role="status"
    >
      <span class="sr-only"></span>
    </div>
  </button>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "button-component",
  data () {
    return {
      loading: false
    };
  },
  props: {
    requires: {
      type: Array
    },
    text: {
      required: false,
      type: String,
      default: "Button"
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    action: {
      type: [Object, Array]
    },
    classes: {
      type: String,
      default: ""
    },
    styles: {
      type: Object,
      default: () => {}
    },
    startCampaignButton: {
      type: Boolean,
      default: false
    },
    addClass: {
      type: String
    },
  },
  computed: {
    ...mapGetters(['hasUnresolvedDependencies']),
    dependencies () {
      return this.hasUnresolvedDependencies(this.requires);
    }
  },
  methods: {
    ...mapActions(['checkEligibility']),
    loginOkta(){
      const campaignName = location.href.split("/")[3];
      this.$auth.loginWithRedirect({
        appState: {
          targetUrl: `/${campaignName}/bank`,
          receiptToken: this.$store.getters.receiptToken,
          customerToken: this.$store.getters.customerToken,
          jwtToken: this.$store.getters.jwtToken,
        },
      });
    },
    registerOkta(){
      const campaignName = location.href.split("/")[3];
      this.$auth.loginWithRedirect({
        appState: {
          targetUrl: `/${campaignName}/bank`,
          receiptToken: this.$store.getters.receiptToken,
          customerToken: this.$store.getters.customerToken,
          jwtToken: this.$store.getters.jwtToken,
        },
        authorizationParams: {
        screen_hint: 'signup',
      },
      });
    },
    async loginGuest() {
      this.$auth.logout({ logoutParams: { returnTo: window.location.origin } });
    },
    async clicked () {
      if(this.action.fn === 'oktaLogin') return this.loginOkta();
      if(this.action.fn === 'oktaRegister') return this.registerOkta();
      if(this.action.params === 'guest-register') {
        this.$store.commit("setGuestSelected", true)
      }
      if(this.action.params === 'auth-select'){
        this.$store.commit("setGuestSelected", null)
      }
      if (this.startCampaignButton) {
        const userIsEligible = await this.checkEligibility()
        if (!userIsEligible) return
      }
      if (!this.action) return;
      if (this.action.anchor) {
        window.location.href = this.action.link
      }
      if (this.action.length > 0) {
        for (let i = 0; i < this.action.length; i++) {
          const act = this.action[i];
          const fn = act.fn;
          const params = act.params;
          await this[fn](params, this);
        }
        return;
      }
      const fn = this.action.fn;
      const params = this.action.params;
      await this[fn](params, this);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/mixins/style/_button.mixin";
@import "@/mixins/style/_color";

.multi-campaign{
  max-width: none;
  width: 100% !important;
  border-radius: 6px !important;
}

.btn {
  @include button();
  &-primary {
    background: $color-3;
    &:focus,
    &:hover {
      background: $color-3-hover;
    }
    &:active {
      background: $color-3-active;
    }
    &:disabled {
      background: $color-3-disabled;
    }
  }
  &-secondary {
    background: transparent;
    border: 1px solid $color-2;
    color: $color-2;
    &:focus,
    &:hover {
      background: transparent;
      border: 1px solid $color-2-hover;
    }
    &:active {
      background: transparent;
      border: 1px solid $color-2-active;
    }
    &:disabled {
      background: transparent;
      border: 1px solid $color-2-disabled;
    }
  }
  &-tertiary {
    background: #FFF;
    border: 2px solid $color-3;
    // font-weight: 500;
    font-size: 18px;
    color: $color-3;
    &:focus,
    &:hover {
      background: #fff;
      border: 2px solid $color-3-hover !important;
    }
    &:active {
      background: #FFF;
      border: 2px solid $color-3-active !important;
    }
    &:disabled {
      background: #FFF;
      border: 2px solid $color-3-disabled !important;
    }
  }

  &-fourth {
    border: 2px solid #A3C6E3;
    background: #A3C6E3;
    color: #00388B;
    &:focus,
    &:hover {
      background: #fff;
      border: 2px solid #00388B !important;
    }
    &:active {
      background: #FFF;
      border: 2px solid #00388B !important;
    }
    &:disabled {
      background: #FFF;
      border: 2px solid #DBD7DA !important;
    }
  }
}
</style>
